import React from 'react';
import { Box, Button, Typography, CircularProgress, Portal } from '@mui/material';
import { Print as PrintIcon } from '@mui/icons-material';
import useStimulsoftPrint from 'app/hooks/useStimulsoftPrint';

const StimulsoftViewer = ({ show, onClose, title = "Report", containerId = 'stimulsoftViewerContent' }) => {
  if (!show) return null;

  return (
    <Portal>
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
          zIndex: 20000,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Box
          sx={{
            backgroundColor: 'white',
            m: 2,
            borderRadius: 1,
            display: 'flex',
            flexDirection: 'column',
            height: 'calc(100% - 32px)',
          }}
        >
          <Box sx={{
            p: 2,
            borderBottom: '1px solid #ccc',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
            <Typography variant="h6">{title}</Typography>
            <Button
              variant="outlined"
              color="secondary"
              onClick={onClose}
            >
              Close
            </Button>
          </Box>
          <Box
            id={containerId}
            sx={{
              flexGrow: 1,
              width: '100%',
              height: '100%',
              overflow: 'hidden',
              // Make Stimulsoft’s injected nodes fill the space
              '& > div': {
                width: '100% !important',
                height: '100% !important',
              },
              '& iframe': {
                width: '100% !important',
                height: '100% !important',
              }
            }}
          />
        </Box>
      </Box>
    </Portal>
  );
};

const PrintButton = ({
  printServiceFunction,
  params = [],
  disabled = false,
  reportTitle = "Report",
  buttonText = "Print",
  color = "secondary",
  variant = "contained",
  startIcon = null,
  size = "medium",
  stopRowPropagation = false,
  containerId = 'stimulsoftViewerContent',
  sx = {},
  ...otherProps
}) => {
  const { showViewer, printLoading, handlePrint, closeViewer } = useStimulsoftPrint();

  const handleClick = (e) => {
    if (stopRowPropagation) {
      e.stopPropagation();
    }
    handlePrint(printServiceFunction, ...params, containerId);
  };
  return (
    <>
      <Button
        color={color}
        variant={variant}
        size={size}
        onClick={handleClick}
        onMouseDown={stopRowPropagation ? (e) => e.stopPropagation() : undefined}
        onTouchStart={stopRowPropagation ? (e) => e.stopPropagation() : undefined}
        disabled={disabled || printLoading}
        startIcon={printLoading ? <CircularProgress size={20} /> : (startIcon || <PrintIcon />)}
        sx={sx}
        {...otherProps}
      >
        {printLoading ? 'Generating...' : buttonText}
      </Button>

      <StimulsoftViewer
        show={showViewer}
        onClose={closeViewer}
        title={reportTitle}
        containerId={containerId}
      />
    </>
  );
};

export default PrintButton;
